// Resolve an image location into a URL the browser can fetch.
//
// Historical images live on the frontend filesystem under /images/<folder>/
// and the DB just stores a bare filename (e.g. "heurigen_juli.jpg"). Since
// adding Azure Blob uploads in the admin, newer entries store a full URL
// (https://storagegisperg.blob.core.windows.net/...) — which used to get
// prepended with /images/<folder>/ resulting in broken double URLs like
// /images/events/https://storagegisperg.blob.core.windows.net/...
//
// This helper handles both: returns absolute URLs untouched, otherwise
// stitches together the legacy local path. Pass an optional file extension
// for places that previously hard-coded `.webp` (e.g. shop showcase images).
export function resolveImageUrl(value, folder, extension) {
    if (!value) return null;
    const v = String(value);
    // Already an absolute URL — leave as is.
    if (/^https?:\/\//i.test(v)) return v;
    // Already a root-relative path (e.g. someone stored "/images/foo.webp")
    // — also leave as is so we don't double-prefix.
    if (v.startsWith('/')) return v;
    const ext = extension ? (extension.startsWith('.') ? extension : `.${extension}`) : '';
    return `/images/${folder}/${v}${ext}`;
}
